module.exports = __webpack_public_path__ + "img/7_99.d75ac326.png";